import UXDDevnetConfig from "./uxd.solana.devnet";
import UXDMainnetConfig from "./uxd.solana.mainnet";
import { Chain, ClusterName, Network } from "./types";

export const getAvailableClusters = (chain: Chain): Array<ClusterName> => {
  switch (chain) {
    case "solana":
      return ["devnet", "mainnet-beta"];
    default:
      throw new Error(`${chain} :: unhandled chain in UXD configuration`);
  }
};

export const getConfigByNetwork = (
  chain: Chain,
  cluster: ClusterName
): typeof UXDDevnetConfig | typeof UXDMainnetConfig => {
  const network: Network = `${chain}/${cluster}`;

  switch (network) {
    case "solana/devnet":
      return UXDDevnetConfig;
    case "solana/mainnet-beta":
      return UXDMainnetConfig;
    default:
      throw new Error(`${cluster} :: unhandled cluster in UXD configuration`);
  }
};
